import React, {Component} from 'react'

import TableCellContainer from '../tablecell/TableCell.container'

class TableRowContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {}

    if (props.rowActions) {
      this.state.rowActions = props.env.callFunction(props.rowActions.comparator, [props.dataRow, props.multiselected])
    }
  }

  componentWillReceiveProps(newProps) {
    if(newProps.multiselected !== this.props.multiselected) {
      if (newProps.rowActions) {
        this.setState({
          rowActions: newProps.env.callFunction(newProps.rowActions.comparator, [newProps.dataRow, newProps.multiselected])
        })
      }
    }
  }

  /**
     * Push row data into datafield
     */
  mergeSubRowConfig() {
    const config = this.props.subRows

    if (config) {
      config.subRowData = this.props.dataRow[this.props.subRows.datafield] || null
    }

    return config
  }

    /**
     *
     * @param {Boolean} checkState
     *
     * Proxy handle multiselect check/uncheck
     */
    handleMultiSelectChanged = (checkState) => {
      this.props.handleMultiSelectChanged(checkState, this.props.dataRow)
    }

    /**
     *
     * @param {Boolean} subrowState
     *
     * Proxy handle open close subrows
     */
    handleSubRowChanged = (subrowState) => {
      this.props.handleSubRowChanged(subrowState, this.props.dataRow.uuid)
    }

    /**
     * @param {Object} header
     *
     * @description Should this cell use a formatter for its contents?
     */
    buildCellFormatter(header) {
      let output = null

      if (header.cellFormatter && header.cellFormatter.enabled) {
        output = header.cellFormatter
      }

      return output
    }

    /**
     *
     * @param {Object} header
     *
     * @description if needed, assemble number in circle to indicate number of child rows. Substituted for cell content if present
     */
    buildSubRowOverride(header) {
      const output = null

      return output
    }

    /**
     * Render array of cells for data items in data object
     */
    renderCells() {
      let count = 0
      const numberOfColumns = this.props.headers.length
      const cells = this.props.headers.map((header, i) => {
        const cellFormatter = this.buildCellFormatter(header)

        count = i

        return (<TableCellContainer
          selectedRows={this.props.selectedRows}
          dataRow={this.props.dataRow}
          env={this.props.env}
          analytics={this.props.analytics}
          rowFlag={this.props.rowFlag}
          count={i}
          multiselect={this.props.multiselect}
          multiselected={this.props.multiselected}
          multiselectenabled={this.props.multiselectenabled}
          handleMultiSelectChanged={this.handleMultiSelectChanged}
          handleSubRowChanged={this.handleSubRowChanged}
          cellFormatter={cellFormatter}
          subRows={this.mergeSubRowConfig()}
          isSubRow={this.props.isSubRow || false}
          scrollOffset={this.props.scrollOffset}
          key={this.props.keyValue + '_cell_' + i}
          dataItem={this.props.dataRow[header.datafield]}
          dataItemStyle={this.props.multiLineRow && this.props.multiLineRow.style}
          header={header}
          freezeCol={this.props.freezeCol}
          showToolTip={header.showToolTip || false}
          lastColumn={numberOfColumns === count + 1}
          firstColumn={count === 0}
          headerChecked={this.props.headerChecked}
        />)
      })

      if (this.props.rowActions) {
        cells.push(<TableCellContainer
          selectedRows={this.props.selectedRows}
          dataRow={this.props.dataRow}
          env={this.props.env}
          analytics={this.props.analytics}
          count={count + 1}
          multiselect={this.props.multiselect}
          multiselected={this.props.multiselected}
          multiselectenabled={this.props.multiselectenabled}
          handleMultiSelectChanged={this.handleMultiSelectChanged}
          handleSubRowChanged={this.handleSubRowChanged}
          subRows={this.mergeSubRowConfig()}
          isSubRow={this.props.isSubRow || false}
          scrollOffset={this.props.scrollOffset}
          isActionCell={true}
          key={this.props.keyValue + '_cell_action'}
          dataItem={this.state.rowActions}
          freezeCol={this.props.freezeCol}
          headerChecked={this.props.headerChecked}
        />)
      }

      if (this.props.multiLineRow && this.props.multiLineRow.enabled) {
        cells.splice(this.props.multiLineRow.columnPosition, 0,
          <TableCellContainer
            selectedRows={this.props.selectedRows}
            dataRow={this.props.dataRow}
            env={this.props.env}
            analytics={this.props.analytics}
            count={count + 2}
            multiselect={this.props.multiselect}
            multiselected={this.props.multiselected}
            multiselectenabled={this.props.multiselectenabled}
            handleMultiSelectChanged={this.handleMultiSelectChanged}
            handleSubRowChanged={this.handleSubRowChanged}
            subRows={this.mergeSubRowConfig()}
            isSubRow={this.props.isSubRow || false}
            scrollOffset={this.props.scrollOffset}
            key={this.props.keyValue + '_cell_multilinecolumn'}
            dataItem={this.props.dataRow && this.props.dataRow.showMultiLine === "true" && this.props.multiLineRow.lineLabel}
            dataItemStyle={'multilinecolumn_' + this.props.multiLineRow.style}
            freezeCol={this.props.freezeCol}
            header={{displayFormat: false}}
            headerChecked={this.props.headerChecked}
          />)
      }

      return cells
    }

    render() {
      return (
        <tr>
          {this.renderCells()}
        </tr>
      )
    }
}

export default TableRowContainer
